/**
 * databases is array of obejects. Each objects defines database structure.
 *      nm: Name of the database
 *      stores : Array of store objects
 *      ver : version of database
 */

/**
 * Store Structure:
 *      nm: Name of store
 *      keyPath : Define a primary key by either defining a key path, or by using a key generator.
 *                If there is no such keys then auto incrementing value can be usedd.
 *                eg: { keyPath: "email" } or { autoIncrement: true }
 *      indexes : Array of object. Each object contains name of index, key on which index get created and options.
 */

/**
 * If any updation happens in dbschema need change the version of database
 */

const DB = {
  GL: 'GarudaLite'
};

const Stores = {
  LatestEventsWts: "LatestEventsWts",
  OldEventsWts: "OldEventsWts",
  LatestDailyStatsMdt: "LatestDailyStatsMdt",
  Triggers: "Triggers",
  GeoFenceTypes: "GeoFenceTypes",
  _TimelineEvents: "_TimelineEvents",
  _DailyStats: "_DailyStats"
}

const DATABASES = [
  {
    nm: DB.GL,
    stores: [
      {
        nm: Stores.LatestEventsWts
      },
      {
        nm: Stores.OldEventsWts
      },
      {
        nm: Stores.LatestDailyStatsMdt
      },
      {
        nm: Stores.Triggers,
        keyPath: { keyPath: 'idx' },
        indexes: [
          { nm: "typ", key: "typ" },
        ],
      },
      {
        nm: Stores.GeoFenceTypes,
        keyPath: { keyPath: 'idx' },
      }
    ],
    ver: 1,
  }
];

function createSchema(vids) {
  if (!vids || !vids.length) return DATABASES;
  else {
    let db = DATABASES.find(db => db.nm = DB.GL);
    vids.forEach(v => {
      let stores = [{
        nm: v + Stores._TimelineEvents,
        keyPath: { autoIncrement: true },
        indexes: [
          { nm: "vid_ts", key: ["vid", "ts"], options: { unique: false } },
          { nm: "vid_ts_t", key: ["vid", "ts", 't'], options: { unique: true } }
        ],
      },
      {
        nm: v + Stores._DailyStats,
        keyPath: { keyPath: ['vid', 'ts'] }
      },];
      db.stores.push.apply(db.stores, stores);
    });
    return DATABASES;
  }
}

module.exports = {
  DB,
  Stores,
  DATABASES,
  createSchema
}
